import React from "react";
import { Card, CardBody, CardTitle, Row } from "reactstrap";
import LineDrawTime from "components/charts/LineDrawTime";

const CategoriesLineDrawTime = ({
  chartClass = "chart-container",
  title,
  data,
  child,
}) => {
  return (
    <Card>
      <CardBody>
        <CardTitle>{title}</CardTitle>
        <div className={"mb-5"}>
          <LineDrawTime data={data.chartData} />
        </div>
        <Row>{child}</Row>
      </CardBody>
    </Card>
  );
};

export default CategoriesLineDrawTime;
